module.exports = {
  content: {
    personalInformation: "个人信息",
    myMessage: "我的消息",
    myOrder: "我的订单",
    myQuestionAndAnswer: "我的问答",
    saleOrder: "售后订单",
    myComment: "我的评价",
    shippingAddress: "收货地址",
    couponPackage: "劵 包",
    changePassword: "更改密码",
    changePhoneNumber: "更换手机号",
    myCollection: "我的收藏",
    browseFootprint: "浏览足迹",
    unbindPhone: "解绑手机",
    customerService: "客户服务",
  }
} 


// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/userCenter/menu.js